import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ce53f206"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tile" }
const _hoisted_7 = {
  key: 1,
  class: "tile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", {
      class: _normalizeClass({ 'side-nav': !_ctx.isMobile, 'top-nav': _ctx.isMobile })
    }, [
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "hamburger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_4))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("ul", {
        class: _normalizeClass({ 'menu-grid': !_ctx.isMobile, 'menu-list': _ctx.isMobile })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name,
            onClick: ($event: any) => (item.action ? item.action() : null),
            class: "menu-item"
          }, [
            (!item.action)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.route
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: item.icon
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]))
          ], 8, _hoisted_5))
        }), 128))
      ], 2), [
        [_vShow, !_ctx.isMobile || _ctx.isMenuOpen]
      ])
    ], 2)
  ]))
}